import { formatUkFullDate, formatUkFullDateTime } from '../lib/calc';

/** Matches common ISO-8601 instants emitted by APIs (Z or numeric offset). */
const ISO_INSTANT_RE =
  /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?(?:Z|[+-]\d{2}:?\d{2}(?::\d{2})?)/g;

/** Space-separated datetime (UTC-ish) sometimes seen in logs. */
const SPACE_DATETIME_RE = /\b(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?)\b/g;

function formatLocaleDateTime(d: Date): string {
  return formatUkFullDateTime(d, '');
}

function formatLocaleDateOnly(d: Date): string {
  return formatUkFullDate(d, '');
}

/**
 * Replaces ISO-8601 datetimes and standalone calendar dates in investigation copy
 * with en-GB locale strings (matches Timeline panel styling).
 */
export function humanizeInvestigationDateTimeText(raw: string): string {
  if (!raw) return '';
  let s = raw.replace(ISO_INSTANT_RE, (match) => {
    const d = new Date(match);
    return Number.isNaN(d.getTime()) ? match : formatLocaleDateTime(d);
  });
  s = s.replace(SPACE_DATETIME_RE, (_, datePart: string, timePart: string) => {
    const d = new Date(`${datePart}T${timePart}Z`);
    return Number.isNaN(d.getTime()) ? `${datePart} ${timePart}` : formatLocaleDateTime(d);
  });
  s = s.replace(/\b(\d{4})-(\d{2})-(\d{2})\b/g, (full, y: string, mo: string, da: string) => {
    const d = new Date(Date.UTC(Number(y), Number(mo) - 1, Number(da), 12, 0, 0));
    return Number.isNaN(d.getTime()) ? full : formatLocaleDateOnly(d);
  });
  return s;
}
